const specificationsArray = [
    {
        id: ['T-Shirt'],
        list: [
            'Fabric',
            'Fit',
            'Length',
            'Main Trend',
            'Multipack Set',
            'Neck',
            'No. of Items',
            'Occasion',
            'Pattern',
            'Pattern Coverage',
            'Pattern Type',
            'Sleeve Length',
            'Sleeve Styling',
            'Sustainable',
            'Wash Care',
            'Weave Type',
        ]
    },
    {
        id: ['Shirt'],
        list: [
            'Fabric',
            'Fit',
            'Sleeve Length',
            'Collar',
            'Pattern type',
            'Occasion',
            'Length',
            'Hemline',
            'Placket Length',
            'Cuff',
            'Transparency',
            'Weave Pattern',
            'Main Trend',
            'Placket'
        ]
    },
    {
        id: ['Sweatshirt & Sweaters'],
        list: [
            'Fabric',
            'Sleeve Length',
            'Neck',
            'Type',
            'Collar',
            'Pattern',
            'Length',
            'Hemline',
            'Wash Care',
        ]
    },
    {
        id: ['Jacket'],
        list: [
            'Lining Fabric',
            'Fabric',
            'Sleeve Length',
            'Collar',
            'Print or Pattern Type',
            'Length',
            'Closure',
            'No. of Pockets',
            'Hemline',
            'Occasion',
        ]
    },
    {
        id: ['Coat & Suits'],
        list: [
            'Fabric',
            'Fit',
            'Collar',
            'Closure',
            'Front Styling',
            'Length',
            'Lining Fabric',
            'Occasion',
            'Pattern',
            'Sleeve Length',
            'Sustainable',
            'Wash Care',
        ]
    },
    {
        id: ['Rain Coat'],
        list: [
            'Fabric',
            'Pattern',
            'Sustainable',
            'Length',
        ]
    },
    {
        id: ['Jeans', 'Pants'],
        list: [
            'Distress',
            'Waist Rise',
            'Fade',
            'Shade',
            'Fit',
            'Length',
            'Waistband',
            'Stretchable',
            'Closure',
            'Reversable',
            'Effect',
            'No. of Pockets',
            'Occasion',
        ]
    },
    {
        id: ['Casual & Formal Trousers'],
        list: [
            'Waist Rise',
            'Length',
            'Fit',
            'Pattern Type',
            'Closure',
            'Type of Pleat',
            'Weave Type',
            'Fly Type',
            'No. of Pockets',
            'Features',
            'Main Trend',
            'Occasion',
            'Package Contains',
        ]
    },
    {
        id: ['Shorts'],
        list: [
            'Waist Rise',
            'Length',
            'Shorts Type',
            'Closure',
            'Pattern Type',
            'Fit',
            'No. of Pockets',
            'Occasion',
            'Knit or Woven',
            'Main Trend',
        ]
    },
    {
        id: ['Track & Jogger'],
        list: [
            'Fabric',
            'Fit',
            'Occasion',
            'Wash Care',
            'Length',
            'No. of Pockets',
            'Closure',
        ]
    },
    {
        id: ['Briefs & Trunks'],
        list: [
            'Inner Type',
            'Fabric',
            'Assorted',
            'Multipack Set',
            'Pattern',
            'Sustainable',
            'Waistband',
            'Wash Care',
        ]
    },
    {
        id: ['Boxer'],
        list: [
            'Fabric',
            'Pattern',
            'Waistband',
            'Wash Care',
            'Knit or Woven',
        ]
    },
    {
        id: ['Vest'],
        list: [
            'Fabric',
            'Fabric Type',
            'Pattern',
            'Neck',
            'Vest Type',
            'Sleeve Length',
            'Wash Care',
        ]
    },
    {
        id: ['Sleepwear & Loungewear'],
        list: [
            'Fabric',
            'Top Fabric',
            'Bottom Fabric',
            'Bottom Closure',
            'Bottom Type',
            'Bottom Pattern',
            'Knit or Woven',
            'Neck',
            'Print or Pattern Type',
            'No. of Items',
            'Sleeve Length',
            'Sustainable',
            'Top Length',
            'Top Pattern',
            'Top Type',
            'Wash Care'
        ]
    },
    {
        id: ['Thermal Wear'],
        list: [
            'Fabric',
            'Neck',
            'Sleeve Length',
            'Wash Care'
        ]
    },
    {
        id: ['Kurtas & Suits'],
        list: [
            'Sleeve Length',
            'Top Type',
            'Bottom Type',
            'Dupatta',
            'Top Pattern',
            'Top Design Styling',
            'Top Hemline',
            'Top Length',
            'Neck',
            'Pattern Type',
            'Bottom Pattern',
            'Bottom Closure',
            'Waist Band',
            'Occasion',
            'Ornamentation',
            'Weave Pattern',
            'Weave Type',
            'Pattern Coverage',
            'Dupatta Pattern',
            'Dupatta Border',
            'Fabric',
        ]
    },
    {
        id: ['Kurti', 'Tunics', 'Tops'],
        list: [
            'Sleeve Length',
            'Types of',
            'Neck',
            'Pattern Type',
            'Fabric',
            'Occasion',
            'Main Trend',
            'Wash Care',
            'Hemline',
            'Sleeve Styling',
            'Weave Pattern',
            'Ornamentation'
        ]
    },
    {
        id: ['Saree'],
        list: [
            'Types of',
            'Fabric',
            'Pattern Type',
            'Occasion',
            'Border',
            'Blouse Fabric',
            'Blouse',
            'Wash Care',
            'Ornamentation'
        ]
    },
    {
        id: ['Leggings', 'Salwars'],
        list: [
            'Types of',
            'Fabric1',
            'Fabric2',
            'Length',
            'Pattern',
            'Sustainable ',
            'Wash Care',
            'Closure',
            'Border',
            'Occasion'
        ]
    },
    {
        id: ['Skirt'],
        list: [
            'Types of',
            'Fabric',
            'Length',
            'Pattern',
            'Hemline',
            'Knit or Woven',
            'Closure',
            'Occasion'
        ]
    },
    {
        id: ['Lehenga Choli'],
        list: [
            'Types of',
            'Fabric',
            'Blouse Fabric',
            'Lehenga Linining Fabric',
            'Ornamentation',
            'Lehenga Closure',
            'Hemline',
            'Neck',
            'Sleeve Length',
            'Sleeve Styling',
            'Lehenga Stich',
            'Choli Stich',
            'Pattern '
        ]
    },
    {
        id: ['Dupatta & Shawl'],
        list: [
            'Fabric',
            'Pattern',
            'Occasion',
            'Wash Care',
            'Border'
        ]
    },
    {
        id: ['Abaya', 'Khimars & Jilbabs'],
        list: [
            'Fabric',
            'Neck',
            'Pattern',
            'Sleeve Length',
            'Sustainable',
            'Type'
        ]
    },
    {
        id: ['Nosepieces'],
        list: [
            'Layer',
            'Fabric',
        ]
    },
    {
        id: ['Hijabs'],
        list: [
            'Fabric',
            'Pattern',
            'Sustainable',
            'Type'
        ]
    },
    {
        id: ['Dresses'],
        list: [
            'Fabric',
            'Shape',
            'Neck',
            'Length',
            'Pattern',
            'Sleeve Length',
            'Sleeve Styling',
            'Occasion',
            'Knit or Woven',
            'Hemline',
            'Surface Styling',
            'Main Trend',
            'Closure'
        ]
    },
    {
        id: ['Playsuit & Jumpsuit'],
        list: [
            'Types of',
            'Fabric',
            'Neck',
            'Sleeve Length',
            'Pattern',
            'Sleeve Styling',
            'Surface Styling',
            'Sustainable',
            'Closure',
            'Washcare'
        ]
    },
    {
        id: ['Bra'],
        list: [
            'Types of',
            'Back',
            'Closure',
            'Fabric',
            'Knit or Woven',
            'Padding',
            'Pattern',
            'Strap',
            'Wring',
            'Center Front Open',
            'Coverage',
            'Fabric2',
            'Features',
            'Seam',
            'Sustainable',
            'Wash Care'
        ]
    },
    {
        id: ['Briefs'],
        list: [
            'Types of',
            'Fabric1',
            'Fabric2',
            'Waist Rise',
            'Pattern',
            'Waist Band',
            'Assorted',
            'Wash Care'
        ]
    },
    {
        id: ['Sleepwear'],
        list: [
            'Types of',
            'Fabric',
            'Wash Care'
        ]
    },
    {
        id: ['Swimmers'],
        list: [
            'Type of ',
            'Fabric',
            'Pattern '
        ]
    },
    {
        id: ['Casual Shoes & Sneakers', 'Formal Shoe'],
        list: [
            'Shoe Type',
            'Toe Shape',
            'Pattern',
            'Fastening',
            'Shoe Width',
            'Ankle Height',
            'Insole',
            'Sole Material',
            'Micro Trend',
            'Warranty',
            'Occasion'
        ]
    },
    {
        id: ['Sports Shoe'],
        list: [
            'Sport',
            'Material',
            'Fastening',
            'Ankle Height',
            'Outsole Type',
            'Cleats',
            'Portion',
            'Arch Type',
            'Cushioning',
            'Surface Type',
            'Warranty'
        ]
    },
    {
        id: ['Sandals & Floaters', 'Flip Flops'],
        list: [
            'Sandals & Floaters Type',
            'Material',
            'Pattern',
            'Fastening',
            'Occasion',
            'Sustainable',
            'Warranty'
        ]
    },
    {
        id: ['Flats'],
        list: [
            'Types of',
            'Fastening and Back Detail',
            'Pattern',
            'Occasion',
            'Ankle Height',
            'Sole Material',
            'Ornamentation',
            'Toe Shape'
        ]
    },
    {
        id: ['Heel'],
        list: [
            'Types of Heel',
            'Type of Heel Wear',
            'Heel Height',
            'Fastening and Back Detail',
            'Pattern',
            'Occasion',
            'Ankle Height',
            'Sole Material',
            'Toe Shape'
        ]
    },
    {
        id: ['Concealer'],
        list: [
            'Concern',
            'Coverage',
            'Finish',
            'Formulation',
            'Key Ingrediant',
            'Preference',
            'Skin Tone ',
            'Skin Type',
            'Sustainable'
        ]
    },
    {
        id: ['Mascara'],
        list: [
            'Colour Shade Name',
            'Features',
            'Finish',
            'Preference',
            'Sustainable'
        ]
    },
    {
        id: ['Foundation'],
        list: [
            'Types of',
            'Colour Shade Name',
            'Concern',
            'Coverage',
            'Finish',
            'Formulation',
            'Skin Type',
            'Sustainable'
        ]
    },
    {
        id: ['Bronzer'],
        list: [
            'Types of',
            'Colour Shade Name',
            'Formulation',
            'Finish',
            'Preference',
            'Skin Type',
            'Skin Tone ',
            'Sustainable'
        ]
    },
    {
        id: ['Blush'],
        list: [
            'Types of Blush',
            'Colour Shade Name',
            'Finish',
            'Formulation',
            'Preference',
            'Skin Type',
            'Skin Tone ',
            'Sustainable'
        ]
    },
    {
        id: ['Primer'],
        list: [
            'Types of',
            'Concern',
            'Coverage',
            'Finish',
            'Formulation',
            'Preference',
            'Skin Tone ',
            'Skin Type',
            'Sustainable'
        ]
    },
    {
        id: ['Eyeliner'],
        list: [
            'Types of',
            'Colour Shade Name',
            'Formulation',
            'Features',
            'Finish',
            'Preference',
            'Sustainable'
        ]
    },
    {
        id: ['Lipstick'],
        list: [
            'Lipstick Type',
            'Shades'
        ]
    },
    {
        id: ['Duffel Bag'],
        list: [
            'Compartment Closure',
            'External Pocket',
            'Features',
            'Material',
            'Number of External Pockets',
            'No. of Main Compartment',
            'Number of Zip',
            'Occasions',
            'Pattern',
            'Side Pocket',
            'Size',
            'Strap Type',
            'Sustainable',
            'Warranty'
        ]
    },
    {
        id: ['BackPack'],
        list: [
            'Types of',
            'Back',
            'Compartment Closure',
            'External Pocket',
            'Haul Loop Type',
            'Laptop Compartment',
            'Laptop Size',
            'Material',
            'Number of External Pocket',
            'Number Of Main Compartment',
            'Number of Zips',
            'Occasion',
            'Padded Shoulder Strap',
            'Pattern Type',
            'Pattern Type ',
            'Side Pocket',
            'Size',
            'Sustainable',
            'Volume in Liters',
            'Water Resistance',
            'Tablet Sleeve'
        ]
    },
    {
        id: ['Wallet'],
        list: [
            'Warranty',
            'Wallet Type',
            'Coin Pocket Type',
            'Length',
            'Material',
            'No. of Coin Pocket',
            'No. of Compartments',
            'No. of ID Card Holder',
            'No. of Slip Pockets',
            'Pattern',
            'Sustainable',
            'Foldable Type',
            'Water Resistance'
        ]
    },
    {
        id: ['Belt'],
        list: [
            'Material',
            'Reversible',
            'Occasion',
            'Closure',
            'Buckle Type',
            'Pattern',
            'Stretchable',
            'Warranty'
        ]
    },
    {
        id: ['Fragrance', 'Body Mist'],
        list: [
            'Category',
            'Fragrance',
            'Preference',
            'Strength',
            'Formulation',
            'Sustainable'
        ]
    },
    {
        id: ['Trimmer'],
        list: [
            'Shaving Clipper',
            'Warranty',
            'Battery',
            'Battery Type'
        ]
    },
    {
        id: ['Braces', 'Cufflinks'],
        list: [
            'Cufflinks Types',
            'Plating',
            'Material',
            'Pattern'
        ]
    },
    {
        id: ['Caps & Hat'],
        list: [
            'Cap Type',
            'Material',
            'Pattern',
            'Occasion',
            'Sustainable',
            'Wash Care',
            'Warranty'
        ]
    },
    {
        id: ['Gloves', 'Scarves & Muffler'],
        list: [
            'Types of',
            'Fabric',
            'Wash Care',
            'Pattern',
            'Border',
            'Sustainable'
        ]
    },
    {
        id: ['Hoodies', 'Crop Hoodies'],
        list: [
            'Sleeve Length',
            'Neck',
            'Pattern',
            'Length',
            'Type',
            'Hood',
            'Closure',
            'No. of Occasion',
            'Hemline',
        ]
    },
    {
        id: ['Sweatshirts'],
        list: [
            'Sleeve Length',
            'Neck',
            'Pattern',
            'Length',
            'Type',
            'Occasion',
        ]
    },
    {
        id: ['T-Shirts'],
        list: [
            'Fabric',
            'Fit',
            'Length',
            'Main Trend',
            'Neck',
            'Occasion',
            'Printed',
            'Sleeve Length',
            'Sleeve Styling',
            'Sustainable',
            'Wash Care',
            'Weave Type',
        ]
    },
    {
        id: ['Facewash'],
        list: [
            'Concern',
            'Formulation',
            'Key Ingredients',
            'Preference',
            'Skin Type',
            'Sustainable',
            'Type',
        ]
    },
    {
        id: ['Serum'],
        list: [
            'Concern',
            'Hair Type',
            'Key Ingredients',
            'Preference',
            'Sustainable',
            'Type',
        ]
    },
    {
        id: ['Moisturizer', 'Foot cream', 'Body lotion'],
        list: [
            'Concern',
            'Formulation',
            'Key Ingredients',
            'Preference',
            'Skin Type',
            'Sustainable',
        ]
    },
    {
        id: ['Under eye cream'],
        list: [
            'Concern',
            'Formulation',
            'Key Ingredients',
            'Skin Type',
            'Sustainable',
        ]
    },
    {
        id: ['Sunscreen'],
        list: [
            'Concern',
            'Formulation',
            'Key Ingredients',
            'Preference',
            'Skin Type',
            'Sustainable',
            'SPF',
        ]
    },
    {
        id: ['Night cream'],
        list: [
            'Key Ingredients',
            'Formulation',
            'Concern',
            'Skin Type',
            'Preference',
        ]
    },
    {
        id: ['Ring'],
        list: [
            'Trend',
            'Material',
            'Stone Type',
            'Plating',
            'Occasion'
        ]
    },
    {
        id: ['Necklace'],
        list: [
            'Base Metal',
            'Closure',
            'Design',
            'Occasion',
            'Sustainable',
        ]
    },
    {
        id: ['Earrings', 'Top'],
        list: [
            'Shape',
            'Type',
            'Base Metal',
            'Stone Type',
            'Closure',
        ]
    },
    {
        id: ['Bracelets'],
        list: [
            'Type',
            'Base Metal',
            'Occasion',
            'Closure',
        ]
    },
    {
        id: ['Pendant'],
        list: [
            'Occasion',
            'Base Model',
            'Stone Type',
            'Shape',
            'Type'
        ]
    },
    {
        id: ['Stud'],
        list: [
            'Base Model',
            'Stone Type',
            'Shape',
            'Type',
            'Platting',
            'Occasion',
            'Closure',
        ]
    },
    {
        id: ['Track Pant'],
        list: [
            'Material type',
            'Style',
            'Closure type',
            'Care instructions',
            'Rise style',
            'Leg style',
            'Country of Origin'
        ]
    },
    {
        id: ['Frocks & Dresses'],
        list: [
            'Material type',
            'Length',
            'Occasion type',
            'Sleeve type',
            'Pattern',
            'Style',
            'Country of Origin'
        ]
    },
    {
        id: ['Ethnic wear'],
        list: [
            'Fabric',
            'Occasion',
            'Wash care',
            'Sleeve Length',
            'Neck',
            'Pattern',
        ]
    },
    {
        id: ['Co-ords & Night Suit'],
        list: [
            'Bottom Closure',
            'Bottom Fabric',
            'Bottom Pattern',
            'Bottom Type',
            'Fabric Type',
            'Knit or Woven',
            'Neck',
            'No. of Items',
            'Package contains',
            'Print or Pattern type',
            'Sleeve Length',
            'Sustainable',
            'Top Fabric',
            'Top Length',
            'Top Pattern',
            'Top Type',
            'Wash Care',
        ]
    },
    {
        id: ['Shrugs'],
        list: [
            'Front Styling',
            'Sleeve Length',
            'Length',
            'Hemline',
            'Wash Care',
        ]
    },
    {
        id: ['Lip Balm'],
        list: [
            'Concerns',
            'Concern 4',
            'Concern 5',
            'Finish',
            'Formulation',
            'Key Ingredient 2',
            'Key Ingredients',
            'Net Quantity Unit',
            'Sustainable',
        ]
    },
    {
        id: ['Lip Scrub'],
        list: [
            'Concerns',
            'Finish',
            'Formulation',
            'Net Quantity',
            'Net Quantity Unit',
            'Preferences',
            'Skin Type',
            'Sustainable',
        ]
    },
    {
        id: ['Face Scrub'],
        list: [
            'Concerns',
            'Key Ingredients',
            'Preferences',
            'Skin Type',
            'Sustainable',
            'Type',
        ]
    },
    {
        id: ['Face Mask'],
        list: [
            'Concerns',
            'Key Ingredients',
            'Net Quantity',
            'Net Quantity Unit',
            'Preferences',
            'Skin Type',
            'Sustainable',
            'Type',
        ]
    },
    {
        id: ['Trousers'],
        list: [
            'Fabric',
            'Waist Rise',
            'Fit',
            'Closure',
            'Type of Pleat',
            'Brand Fit Name',
            'Weave Type',
            'Fly Type',
            'Number of pockets',
            'Features',
            'Number of items',
            'Package Contains',
            'Net quantity',
        ]
    },
    {
        id: ['Face Toner'],
        list: [
            'Concerns',
            'Key Ingredients',
            'Preferences',
            'Skin Types'
        ]
    },
    {
        id: ['Mist'],
        list: [
            'Formulation',
            'Fragrance',
            'Net Quantity Unit',
            'Strength',
            'Sustainable',
            'Skin Type',
            'Active Ingredients',
            'Product Type'
        ]
    },
    {
        id: ['Face Cleanser'],
        list: [
            'Skin Concern',
            'Skin Type',
            'Active Ingredients',
            'Formulation',
            'Type'
        ]
    },
    {
        id: ['Face Roller'],
        list: [
            'Concerns',
            'Net Quantity',
            'Net Quantity Unit',
            'Sustainable',
            'Product Type',
        ]
    },
    {
        id: ['Aroma Candles'],
        list: [
            'Features',
            'Active Ingredients'
        ]
    },
    {
        id: ['Essential Oils'],
        list: [
            'Concerns',
            'Key Ingredient',
            'Key Ingredient 2',
            'Preferences',
            'Skin Type',
            'Skin Type 2',
            'Skin Type 3',
            'Skin Type 4',
            'Net Quantity Unit',
            'Sustainable',
            'Type'
        ]
    },
    {
        id: ['Co-ords'],
        list: [
            'Bottom Closure',
            'Bottom Pattern',
            'Neck',
            'Net Quantity Unit',
            'Net Quantity',
            'Number of Pockets',
            'Number of Items',
            'Number of Pockets',
            'Stitch',
            'Top Fabric',
            'Top Type',
            'Bottom Fabric',
            'Bottom Type',
            'Occasions',
            'Sleeve Length',
            'Sustainable',
            'Top Pattern',
            'Wash Care'
        ]
    },
    {
        id: ['Waistcoat'],
        list: [
            'Weave Type',
            'Number of Pockets',
            'Wash Care',
            'Neck style',
            'Material',
            'Fit type',
            'Closure type'
        ],
    },
    {
        id: ['Co-ords Set'],
        list: [
            'Bottom Closure',
            'Bottom Pattern',
            'Neck',
            'Net Quantity Unit',
            'Number of Pockets',
            'Package Contains',
            'Stitch',
            'Top Fabric',
            'Top Type',
            'Bottom Fabric',
            'Bottom Type',
            'Net Quantity',
            'Number of Items',
            'Occasions',
            'Sleeve Length',
            'Sustainable',
            'Top Pattern',
            'Wash Care'
        ],
    },
    {
        id: ['Kurta'],
        list: [
            'Sleeve Length',
            'Neck',
            'Slit Detail',
            'Hemline',
            'Weave Pattern',
            'Number of Items',
            'Shape',
            'Design Styling',
            'Length',
            'Colour Family',
            'Weave Type'
        ],
    },
    {
        id: ['Kurta Set'],
        list: [
            'Sleeve Length',
            'Top Type',
            'Dupatta',
            'Top Design Styling',
            'Top Length',
            'Bottom Pattern',
            'Waistband',
            'Weave Pattern',
            'Pattern Coverage',
            'Number of Items',
            'Top Shape',
            'Bottom Type',
            'Top Pattern',
            'Top Hemline',
            'Neck',
            'Bottom Closure',
            'Ornamentation',
            'Weave Type',
            'Dupatta Pattern',
            'Package Contains'
        ],
    },
    {
        id: ['Track Pants'],
        list: [
            'Fabric',
            'Fit',
            'Type',
            'Wash Care',
            'Length',
            'Number of Pockets',
            'Closure',
            'Net Quantity'
        ],
    },
    {
        id: ['Tracksuits'],
        list: [
            'Neck',
            'Sleeve Length',
            'Waist Rise',
            'Wash Care',
            'Number of Items',
        ],
    },
    {
        id: ['Cargo'],
        list: [
            'Waist Rise',
            'Length',
            'Fit',
            'Brand Fit Name',
            'Closure',
            'Type of Pleat',
            'Weave Type',
            'Fly Type',
            'Number of Pockets',
            'Features',
            'Number of Items',
            'Package Contains',
        ],
    },
    {
        id: ['Jeggings'],
        list: [
            'Closure',
            'Fit',
            'Type',
            'Multipack Set',
            'Wash Care',
            'Weave Type',
            'Number of Items',
        ],
    },
    {
        id: ['Shorts - Women'],
        list: [
            'Fabric',
            'Waist Rise',
            'Waistband',
            'Wash Care',
            'Closure',
            'Number of Pockets',
            'Net Quantity',
        ],
    },
    {
        id: ['Blankets'],
        list: [
            'Fabrics',
            'Print or Pattern Types',
            'Sustainable',
            'Type',
            'Utility',
            'Wash Care',
            'Net Quantity Unit',
        ],
    },
    {
        id: ['Towels'],
        list: [
            'Type',
            'Use For',
            'Set Size',
            'GSM',
        ],
    },
    {
        id: ['Bedding Set'],
        list: [
            'Quality',
            'Bed Size',
            'Number of Bedsheets',
            'Number of Pillow Covers',
            'Utility',
        ],
    },
    {
        id: ['Girls Clothing set'],
        list: [
            'Sleeve Length',
            'Add-Ons',
            'Bottom Fabric',
            'Top Type',
            'Top Pattern',
            'Wash Care',
            'Neck',
            'Top Fabric',
            'Bottom Type',
            'Bottom Pattern',
            'Bottom Closure',
        ],
    },
    {
        id: ['Jackets & Coats'],
        list: [
            'Sleeve Length',
            'Type',
            'Type',
            'Length',
            'Closure',
            'Lining Fabric',
            'Number of Pockets',
            'Hemline',
            'Number of Items',
            'Package Contains',
        ],
    },
    {
        id: ['Boys Clothing Set'],
        list: [
            'Closure',
            'Top Fabric',
            'Bottom Fabric',
            'Neck',
            'Net Quantity Unit',
            'Number of Items',
            'Occasions',
            'Package Contains',
            'Patterns',
            'Sleeve Length',
            'Sustainable',
            'Type',
            'Wash Care',
            'Trouser Fit',
            'Waistband',
            'Length',
            'Silhouette',
        ],
    },
    {
        id: ['Jumpsuits & Dungarees'],
        list: [
            'Closure',
            'Neck',
            'Number of Items',
            'Occasions',
            'Patterns',
            'Sustainable',
            'Fabrics',
            'Net Quantity Unit',
            'Number of Pockets',
            'Package Contains',
            'Sleeve Length',
            'Type',
            'Wash Care',
            'Trouser Fit',
            'Waistband',
        ],
    }
]

export {
    specificationsArray,
}